import { type DisbursementAccountFields } from '@resurs-internal/deposits-app-components';

import { validations } from '@/assets';
import { validationError, validationMessage } from '@/helpers';
import { lookupBankName, validateBBAN } from '@/services';
import { type DisbursementAccount } from '@/types/consumer-deposit-application-service';

import { type InitialApplication } from './useApplication';

export const disbursementAccount = ({
  application,
  country,
  save,
}: InitialApplication): DisbursementAccountFields => {
  const { accountNumber, accountPrefix } = application.disbursementAccount || {
    accountNumber: undefined,
    accountPrefix: undefined,
  };
  const initialAddAccount: boolean | undefined = application.disbursementAccount
    ? true
    : application.bankruptcyDetails?.declaredBankruptcy !== undefined
      ? false
      : undefined;

  const saveDisbursementAccount = async (
    disbursementAccount: DisbursementAccount | undefined,
  ) => {
    return save({ disbursementAccount });
  };

  const validateAddAccount = (addAccount: boolean | undefined): string =>
    addAccount === undefined ? 'component.empty' : '';

  const validateAccountPrefix = async (accountPrefix: string) => {
    const errorMessage = validationMessage(
      true,
      validations[country].accountPrefix,
      validationError(validations[country].accountPrefix, accountPrefix),
    );

    if (errorMessage) return errorMessage;

    try {
      await lookupBankName(country, accountPrefix);
    } catch {
      return 'category.disbursement-account.clearing-number.validation-error.invalid';
    }

    return '';
  };

  const validateAccountNumber = async (
    accountNumber: string,
    accountPrefix: string,
  ) => {
    const errorMessage = validationMessage(
      true,
      validations[country].accountNumber,
      validationError(validations[country].accountNumber, accountNumber),
    );

    if (errorMessage) return errorMessage;

    try {
      await validateBBAN(country, accountPrefix, accountNumber);
    } catch {
      return 'category.disbursement-account.account-number.validation-error.invalid';
    }

    return '';
  };

  return {
    initialAccountNumber: accountNumber,
    initialAccountPrefix: accountPrefix,
    initialAddAccount,
    saveDisbursementAccount,
    validateAccountNumber,
    validateAccountPrefix,
    validateAddAccount,
  };
};
